var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-user-selector-main bc-cCFF" }, [
    _c("div", { staticClass: "flex w100p bbF0 ptb24" }, [
      _c("div", { staticClass: "flex align-items-center w1200 m0auto" }, [
        _c("div", { staticClass: "hl30 fs24 fw500" }, [
          _vm._v(_vm._s(_vm.language().tit_dialogtitle)),
        ]),
        _c(
          "div",
          { staticClass: "fs14 ml25 flex align-items-center c-cC8C" },
          [
            _vm._v(" " + _vm._s(_vm.language().tit_dialogtip) + " \n        "),
            _c(
              "yxt-popover",
              {
                staticClass: "yxtbiz-user-selector-tooltip",
                attrs: {
                  title: _vm.language().tit_explain,
                  width: "256",
                  placement: "top-start",
                },
              },
              [
                _c("yxt-svg", {
                  staticClass: "size-16 ml4 color-gray-6",
                  attrs: {
                    slot: "reference",
                    "icon-class": "question-cirlce-o",
                  },
                  slot: "reference",
                }),
                _c("ul", { staticClass: "yxtbiz-signup" }, [
                  _c("li", { staticClass: "flex align-items-center" }, [
                    _c("div", { staticClass: "dotsmall dotdis" }),
                    _vm._v(" " + _vm._s(_vm.language().msg_explain_one)),
                  ]),
                  _c("li", { staticClass: "flex align-items-center" }, [
                    _c("div", { staticClass: "dotsmall dotdis" }),
                    _vm._v(" " + _vm._s(_vm.language().msg_explain_two)),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("i", {
        staticClass: "yxt-icon-close yxtbiz-user-selector-close c-cC59 t32",
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.closeDialog()
          },
        },
      }),
    ]),
    _c("div", { staticClass: "flex m0auto maxw1200 flex-value-1 bc-cCFF" }, [
      _c("div", { staticClass: "yxtbiz-user-selector-center-left" }, [
        _c(
          "div",
          { staticClass: "yxtbiz-user-selector-center-left-wrap" },
          [
            _c(
              "div",
              { staticClass: "flex space-between mb8" },
              [
                _c(
                  "yxt-select",
                  {
                    staticClass: "w180 mr24",
                    attrs: {
                      placeholder: _vm.language().lbl_registration_status,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.getData()
                      },
                    },
                    model: {
                      value: _vm.auditStatus,
                      callback: function ($$v) {
                        _vm.auditStatus = $$v
                      },
                      expression: "auditStatus",
                    },
                  },
                  _vm._l(_vm.statuList, function (item) {
                    return _c("yxt-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
                _c("yxtf-input", {
                  staticClass: "w260",
                  attrs: {
                    placeholder: _vm.language().msg_input,
                    searchable: "",
                    clearable: "",
                    maxlength: "50",
                  },
                  on: {
                    clear: function ($event) {
                      return _vm.getData()
                    },
                    search: function ($event) {
                      return _vm.getData()
                    },
                  },
                  model: {
                    value: _vm.query.keyword,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "keyword", $$v)
                    },
                    expression: "query.keyword",
                  },
                }),
              ],
              1
            ),
            _c(
              "yxt-table",
              {
                ref: "multipleTable",
                staticClass: "mr16",
                attrs: {
                  data: _vm.tableData,
                  loading: _vm.loading,
                  "start-custom-column": true,
                  "header-cell-class-name": "yxtbiz-user-selector-table-header",
                  "cell-class-name": "yxtbiz-user-selector-table-cell",
                },
                on: {
                  "selection-change": _vm.handleSelectionChange,
                  "row-click": _vm.handleSelectionRowChange,
                },
              },
              [
                _c("yxt-table-column", {
                  attrs: {
                    type: "selection",
                    "clear-padding": "left-right",
                    selectable: function (row) {
                      return row.auditStatus === -1
                    },
                    width: "34",
                  },
                }),
                _c("yxt-table-column", {
                  attrs: {
                    prop: "fullname",
                    label: _vm.language().lbl_name,
                    "min-width": "200",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "flex" }, [
                            _c(
                              "div",
                              [
                                _c("yxtf-portrait", {
                                  staticClass: "mr8",
                                  attrs: {
                                    imgUrl: scope.row.imgUrl,
                                    size: "36px",
                                    username: scope.row.fullname,
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "h40" },
                              [
                                _c(
                                  "yxt-tooltip",
                                  {
                                    staticClass:
                                      "w200 ellipsis block fs14 h22 lh22",
                                    attrs: {
                                      effect: "dark",
                                      placement: "top",
                                      "open-filter": true,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      [
                                        _c("yxtbiz-user-name", {
                                          attrs: { name: scope.row.fullname },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _c("yxtbiz-user-name", {
                                          attrs: { name: scope.row.fullname },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-cC75 block ellipsis w200 fs12 h20",
                                    attrs: { title: scope.row.username },
                                  },
                                  [_vm._v(_vm._s(scope.row.username))]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("yxt-table-column", {
                  attrs: {
                    prop: "positionName",
                    label: _vm.language().lbl_position_name,
                    "min-width": "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "c-cC75" },
                            [
                              _c("yxtbiz-position-name", {
                                attrs: { name: scope.row.positionName || "--" },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("yxt-table-column", {
                  attrs: {
                    prop: "status",
                    label: _vm.language().lbl_status,
                    "hide-column": false,
                    "min-width": "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", {
                            class: [
                              scope.row.auditStatus === -1 ? "dot1" : "dotdis",
                              "dot",
                            ],
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.getStatus(scope.row.auditStatus))
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "flex space-between pt12 pb19 pl16" },
          [
            _c("div", { staticClass: "c-cC59" }, [
              _vm._v(_vm._s(_vm.language().lbl_selected) + " "),
              _c("span", { staticClass: "c-cC436BFF fs16" }, [
                _vm._v(_vm._s(_vm.multipleSelectionValue.length)),
              ]),
              _vm._v(" " + _vm._s(_vm.language().lbl_people)),
            ]),
            _c("yxtf-pagination", {
              staticClass: "yxtbiz-user-selector-page-right",
              attrs: {
                layout: "prev, pager, next",
                "current-page": _vm.current,
                total: _vm.total,
                "page-size": _vm.query.limit,
              },
              on: {
                "update:currentPage": function ($event) {
                  _vm.current = $event
                },
                "update:current-page": function ($event) {
                  _vm.current = $event
                },
                "current-change": _vm.getData,
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "yxtbiz-user-selector-center-right" }, [
        _c(
          "div",
          {
            staticStyle: {
              position: "absolute",
              top: "0",
              bottom: "55px",
              left: "0",
              right: "0",
              overflow: "auto",
              padding: "24px 24px 0",
            },
          },
          _vm._l(_vm.multipleSelectionValue, function (tag, index) {
            return _c(
              "yxtf-tag",
              {
                key: index,
                staticClass: "mb12",
                attrs: {
                  type: "info",
                  title: tag.fullname,
                  size: "mini",
                  closable: "",
                  "disable-transitions": false,
                },
                on: {
                  close: function ($event) {
                    return _vm.handleClose(tag, index)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "yxtbiz-user-selector-tagname c-cC59" },
                  [_c("yxtbiz-user-name", { attrs: { name: tag.fullname } })],
                  1
                ),
              ]
            )
          }),
          1
        ),
        _vm.multipleSelectionValue.length > 0
          ? _c(
              "div",
              { staticClass: "yxtbiz-user-selector-tag-footer c-cC59" },
              [
                _c(
                  "div",
                  {
                    staticClass: "pointer",
                    on: {
                      click: function ($event) {
                        return _vm.clearAll()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.language().btn_clear_all))]
                ),
                _vm.max
                  ? _c(
                      "div",
                      {
                        class:
                          _vm.max >= _vm.multipleSelectionValue.length
                            ? ""
                            : "c-cCRed",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.max >= _vm.multipleSelectionValue.length
                                ? _vm.language().lbl_remaining_quota
                                : _vm.language().lbl_over_quota
                            ) +
                            "\n          "
                        ),
                        _c(
                          "span",
                          {
                            class:
                              "fs16 " +
                              (_vm.max >= _vm.multipleSelectionValue.length
                                ? "c-cC436BFF"
                                : ""),
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.max >= _vm.multipleSelectionValue.length
                                  ? _vm.max - _vm.multipleSelectionValue.length
                                  : _vm.multipleSelectionValue.length - _vm.max
                              )
                            ),
                          ]
                        ),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.language().lbl_people) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ]),
    ]),
    _c("div", { staticClass: "w100p pt24 pb23 btF0 bc-cCFF" }, [
      _c(
        "div",
        { staticClass: "w1200 m0auto" },
        [
          _c(
            "yxtf-button",
            {
              attrs: {
                type: "primary",
                disabled:
                  _vm.multipleSelectionValue.length === 0 ||
                  (_vm.max && _vm.max < _vm.multipleSelectionValue.length) ||
                  _vm.multipleSelectionValue.length > 20,
              },
              on: {
                click: function ($event) {
                  return _vm.handleSure()
                },
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.multipleSelectionValue.length > 20
                    ? _vm.language().lbl_exceeded +
                        20 +
                        _vm.language().lbl_people
                    : _vm.language().btn_save_sign_up
                )
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }